import api from ".";

export const signin = (data, callBack) => {
  api.post(`/login/`, data)
    .then((response) => {
      callBack(response?.data);
    })
    .catch((error) => {
      callBack(error?.response);
    });
};

export const signup = (data, callBack) => {
  api.post(`/register/`, data)
    .then((response) => {
      callBack(response?.data);
    })
    .catch((error) => {
      callBack(error?.response);
    });
};

export const dynamicRegisterForm = (data, callBack) => {
  api.post(`/companies/`, data)
    .then((response) => {
      callBack(response?.data);
    })
    .catch((error) => {
      callBack(error?.response);
    });
};

export const forgetpassword = (data, callBack) => {
  api.post(`/forgot-password/`, data)
    .then((response) => {
      callBack(response);
    })
    .catch((error) => {
      callBack(error?.response);
    });
};

export const resetpassword = (token, data, callBack) => {
  api.post(`/reset-password/${token}/`, data)
    .then((response) => {
      callBack(response);
    })
    .catch((error) => {
      callBack(error?.response);
    });
};

export const getMe = ({ }, callBack) => {
  api.get('/user/', {})
    .then((response) => {
      callBack(response?.data);
    })
    .catch((error) => {
      callBack(error?.response);
    })
}

export const updateUserDetails = (id, data, callBack) => {
  const config = data instanceof FormData
    ? { headers: { 'Content-Type': 'multipart/form-data' } }
    : {};
  api.put(`/user/${id}/`, data, config)
    .then((response) => {
      callBack(response?.data);
    })
    .catch((error) => {
      callBack(error?.response);
    })
}

export const changePassword = (data, callBack) => {
  api.put(`/change-password/`, data)
    .then((response) => {
      callBack(response?.data);
    })
    .catch((error) => {
      callBack(error?.response);
    })
}

export const memberEmailVerification = (data, callBack) => {
  api.post(`/check-email/`, data)
    .then((response) => {
      callBack(response);
    })
    .catch((error) => {
      callBack(error?.response);
    });
};

export const verifyOtp = (data, callBack) => {
  api.post(`/verify-email-otp/`, data)
    .then((response) => {
      callBack(response?.data);
    })
    .catch((error) => {
      callBack(error?.response);
    });
};

export const resendOtp = (data, callBack) => {
  api.post(`/resend-email-otp/`, data)
    .then((response) => {
      callBack(response?.data);
    })
    .catch((error) => {
      callBack(error?.response);
    });
};

export const getTermsOfService = (params = {}) => {
  return api.get(`/terms-of-service/`, { params })
    .then((response) => response.data)
    .catch((error) => {
      throw error?.response?.data || error;
    });
};

export const getPrivacyPolicy = (params = {}) => {
  return api.get(`/privacy-policy/`, { params })
    .then((response) => response.data)
    .catch((error) => {
      throw error?.response?.data || error;
    });
};


